<template>
  <el-dialog
      :title="setId?'编辑社区':'新增社区'"
      :visible.sync="projectDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="600px"
      center>
    <el-form :model="projectForm" :rules="rules" ref="projectForm" label-width="100px">
      <el-form-item label="社区名称" prop="name">
        <el-input v-model="projectForm.name" placeholder="请输入姓名"></el-input>
      </el-form-item>
      <el-form-item label="社区" prop="xiangmujingliId">
        <el-select v-model="projectForm.xiangmujingliId" placeholder="请选择社区" style="width: 100%;" @change="setPhone">
          <el-option
              v-for="item in xmhlList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="联系电话" prop="phone">
        <el-input v-model="projectForm.phone" readonly placeholder="请输入手机号"></el-input>
      </el-form-item>
      <el-form-item label="社区地区" prop="region">
        <el-cascader
            style="width: 100%;"
            expand-trigger="hover"
            filterable
            placeholder="请选择机构所在地"
            :options="options"
            v-model="projectForm.region"
            @change="addressChange"
        >
        </el-cascader>
      </el-form-item>
      <el-form-item label="详细地址" prop="address">
        <el-input v-model="projectForm.address" placeholder="请输入详细地址"></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="beizhu">
        <el-input type="textarea" v-model="projectForm.beizhu" placeholder="请输入备注"></el-input>
      </el-form-item>
      <el-form-item class="flex align-center justify-around" label-width="0">
        <el-button class="padding-lr-xl" @click="resetForm('projectForm')">取消</el-button>
        <el-button class="padding-lr-xl" type="primary" @click="submitForm('projectForm')">提交</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import {regionData, CodeToText} from "element-china-area-data";
import rules from '@/utils/rules'
import {jingLiList, xiangMuAdd} from "@/api/project";

export default {
  name: "projectDialog",
  props: {
    projectDialog: {
      type: Boolean,
      default: false
    },
    setId: {
      type: Number,
      default() {
        return 0;
      }
    },
    setItem: {
      type: Object
    }
  },
  data() {
    return {
      xmhlList: [],
      options: regionData,
      projectForm: {
        name: '',
        xiangmujingliId: '',
        phone: '',
        region: [],
        region_text: [],
        address: '',
        beizhu: '',
      },
      rules: {
        name: [{required: true, message: '请输入社区名称', trigger: 'blur'}],
        xiangmujingliId: [{required: true, message: '请选择社区', trigger: 'change'}],
        phone: rules.phone,
        region: [{required: true, message: '请选择社区地区', trigger: 'change'}],
        address: [{required: true, message: '请输入详细地址', trigger: 'blur'}],
      }
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  created() {

  },
  methods: {
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$emit('cancelDialog', false)
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData(formName)
        }
      });
    },
    async submitData(formName) {
      let _state = await xiangMuAdd(
          this.projectForm.name,
          this.projectForm.xiangmujingliId,
          this.projectForm.region[0],
          this.projectForm.region_text[0],
          this.projectForm.region[1],
          this.projectForm.region_text[1],
          this.projectForm.region[2],
          this.projectForm.region_text[2],
          this.projectForm.address,
          this.projectForm.beizhu,
          this.setId ? this.setId : '',
      );
      this.$message.success(_state.info);
      this.$refs[formName].resetFields();
      this.$emit("cancelDialog", true);
    },
    //  根据地址code 换取 地址Zh
    addressChange(arr) {
      this.projectForm.region = arr;
      this.projectForm.region_text = [CodeToText[arr[0]], CodeToText[arr[1]], CodeToText[arr[2]]];
    },
    //  获取社区电话
    setPhone(val) {
      let _item = this.xmhlList.filter(item => item.id === val)
      this.projectForm.phone = _item[0].username
    },
    //  获取社区
    async jingLiList() {
      let _list = await jingLiList(2,this.setId)
      this.xmhlList = _list.data
    }
  },
  watch: {
    projectDialog(){
      if(this.projectDialog) this.jingLiList()
    },
    setItem() {
      this.projectForm = {
        name: this.setItem.name,
        xiangmujingliId: this.setItem.xiangmujingli_id,
        phone: this.setItem.xiangmujingli_phone,
        region: this.setItem.sheng_id?[this.setItem.sheng_id.toString(), this.setItem.shi_id.toString(), this.setItem.qu_id.toString()]:[],
        region_text: this.setItem.sheng_name?[this.setItem.sheng_name, this.setItem.shi_name, this.setItem.qu_name]:[],
        address: this.setItem.address,
        beizhu: this.setItem.beizhu
      };
    }
  }
}
</script>

<style scoped lang="scss">

</style>
